import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Full-width background image */}
      <img
        src="https://storage.readdy-site.link/project_files/24cbc93a-97c5-4a4c-8795-e638165a0b41/9f0d6090-fe6d-4f45-826f-0f64ae55dfdd_shutterstock_2686209423.jpg?v=7fb9d7b6cc1f9215602fd649bccfc6e8"
        alt="Luxury Pennsylvania home - Black Dog Settlement title services Bucks County"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/55"></div>

      {/* Content - centered over image */}
      <div className="relative z-10 w-full flex flex-col items-center justify-center text-center px-6 md:px-12 pt-36 md:pt-24 pb-20">
        <div className="flex items-center gap-3 mb-7">
          <div className="w-8 h-px bg-[#c9a84c]"></div>
          <span className="text-[#c9a84c] text-xs font-bold tracking-[0.3em] uppercase">Newtown, Pennsylvania</span>
          <div className="w-8 h-px bg-[#c9a84c]"></div>
        </div>

        <h1
          className="text-5xl md:text-7xl lg:text-[80px] font-black text-white leading-[1.0] mb-8 tracking-tight"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Title &amp; Settlement<br />
          <span className="text-[#c9a84c]">Services.</span>
        </h1>

        <p className="text-white/60 text-base md:text-lg leading-relaxed mb-10 max-w-xl">
          Professional real estate closings for buyers, sellers, and agents across Bucks, Montgomery, Chester &amp; Delaware County, PA.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 mb-14">
          <a
            href="tel:2154990796"
            className="inline-flex items-center justify-center gap-2 bg-[#c9a84c] hover:bg-[#b8963e] text-[#0f0f0f] font-bold px-8 py-4 text-xs tracking-[0.15em] uppercase whitespace-nowrap cursor-pointer transition-all duration-200"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line"></i>
            </div>
            Call 215-499-0796
          </a>
          <Link
            to="/services"
            className="inline-flex items-center justify-center gap-2 border border-white/40 hover:border-white/80 text-white font-bold px-8 py-4 text-xs tracking-[0.15em] uppercase whitespace-nowrap cursor-pointer transition-all duration-200"
          >
            Our Services
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        {/* County badges */}
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          {['Bucks County', 'Montgomery County', 'Chester County', 'Delaware County'].map((c) => (
            <div key={c} className="flex items-center gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-[#c9a84c] shrink-0"></div>
              <span className="text-white/40 text-xs">{c}, PA</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-white/30 animate-bounce">
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-down-line text-sm"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
